/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
import React from "react";
import { isMobile, isTablet } from "react-device-detect";
import { Navigate, useLocation } from "react-router-dom";
import { ROUTES } from "src/config/user-authorization";
import { PARTNERS } from "src/constants";
import { useSelector } from "react-redux";
import queryString from "query-string";

const findPathName = (user, pathname) => {
  const {
    data: {
      required_fields_filled: requiredFieldsFilled,
      institute_type: instituteType,
    },
  } = user;

  if (isMobile || isTablet) {
    return ROUTES.EVENTS_LIST;
  }
  if (pathname.includes("web")) {
    if (requiredFieldsFilled) {
      return ROUTES.WEBINARS;
    }
    return ROUTES.WEBINARS_USER_UPDATE;
  }

  if (instituteType === PARTNERS.SCHOOLS) {
    return ROUTES.EVENTS;
  }
  return ROUTES.DASHBOARD;
};

const UnAuthenticatedWrapper = ({ Component, ...rest }) => {
  const user = useSelector(state => state.user);
  const location = useLocation();
  const paths = location.pathname.split("/");
  const pathname = paths[1];

  const redirectToCialfoExplore = () => {
    window.location.replace("https://www.explore.study/");
    return null;
  };

  const queryParams = queryString.parse(location.search);

  if (queryParams.redirect_to) {
    if (user.authToken) {
      return (
        <Navigate
          to={`/${queryParams.redirect_to}${location.search}`}
          replace
        />
      );
    }
    if (!pathname) {
      return (
        <Navigate
          to={`${ROUTES.SIGN_IN}${location.search}`}
          replace
        />
      );
    }
  }

  return user.authToken ? (
    <Navigate
      to={`${findPathName(user, pathname)}${location.search}`}
      replace
    />
  ) : !pathname ? (
    redirectToCialfoExplore()
  ) : (
    <Component {...rest} />
  );
};

const UnAuthenticated = ({ component: Component, ...rest }) => {
  return <UnAuthenticatedWrapper Component={Component} {...rest} />;
};

export default UnAuthenticated;
